import { ApiRoutes } from "consts/enpoints/api";
import { fetchApi } from "infrastructure/api";
import type { MerchantsMethodsPivot, MerchantsNotificationChannelsPivot } from "./types";

export const getMerchantsMethodsPivot = (queryString = '') =>
    fetchApi(`${ApiRoutes.GetMerchantsMethodsPivot}${queryString}`);

export const updateMerchantsMethodsPivot = ({
    coreId,
    ...body
}: Pick<
    MerchantsMethodsPivot,
    | 'coreId'
    | 'shouldKyc'
>) =>
    fetchApi(ApiRoutes.PutMerchantsMethodsPivot(coreId), {
        method: 'PUT',
        body
    });

export const getMerchantsNotificationChannelsPivot = (queryString = '') =>
    fetchApi(`${ApiRoutes.GetMerchantsNotificationChannelsPivot}${queryString}`);

export const updateOrCreateMerchantsNotificationChannelsPivot = (body:
    & Pick<
        MerchantsNotificationChannelsPivot,
        | 'merchantId'
        | 'notificationChannelId'
    >
    & Partial<MerchantsNotificationChannelsPivot>
) => {
    const { merchantId, notificationChannelId } = body;

    return fetchApi(ApiRoutes.PutMerchantsNotificationChannelsPivot(
        merchantId,
        notificationChannelId
    ), {
        method: 'PUT',
        body
    });
};
